import { svg } from "lit";
const icon = svg `<path d="M5 7.90375V19H19V7.90375H15.5V15.298L12 13.548L8.5 15.298V7.90375H5ZM3.5 20.5V6.35775L5.85775 3.5H18.1328L20.5 6.377V20.5H3.5ZM5.3905 6.404H18.6L17.4135 5H6.577L5.3905 6.404ZM10 7.90375V12.8558L12 11.8558L14 12.8558V7.90375H10Z" fill="currentColor"/>`;
export default icon;
